module.exports = __webpack_public_path__ + "static/media/comsystems-logo.af89c3bf.png";